import moment from "moment";
import { defineStore } from 'pinia'

export const useDeliveryStore = defineStore('delivery', {
    state: () => ({
        delivery_medicines:[],
    }),
    actions: {
        save_data(record) {
            let exists = false;
            for (let i=0;i<this.delivery_medicines.length;i++) {
                if ((record.stock_id > 0 && this.delivery_medicines[i].stock_id == record.stock_id) || (record.stock_id == 0 && this.delivery_medicines[i].medicine_id == record.medicine_id && this.delivery_medicines[i].lot_no == record.lot_no)) {                    this.delivery_medicines[i].number = record.number;
                    this.delivery_medicines[i].order_number = record.order_number;
                    exists = true;
                    break;
                }
            }
            if (exists == false) {
                //レコードを保存する時刻を記録する
                record.action_save_time = moment().format("YYYY-MM-DD HH:mm:ss");
                this.delivery_medicines.push(record);
            }
        },
        delete_data(stock_id,medicine_id) { // TODO
            for (let i=0;i<this.delivery_medicines.length;i++) {
                if ((stock_id > 0 && this.delivery_medicines[i].stock_id == stock_id) || (stock_id == 0 && this.delivery_medicines[i].medicine_id == medicine_id)) {
                    this.delivery_medicines.splice(i,1);
                    break;
                }
            }
        },
        reset_data() {
            this.delivery_medicines.splice(0);
        }
    },
    persist: true,
})
